import { mapSettingsAtom } from "./atoms";
import { useAtom } from "jotai";

export function useMapSettings() {
  const [{ data, error, isLoading }] = useAtom(mapSettingsAtom);
  return {
    mapSettings: data,
    error,
    isLoading,
  };
}
